import classNames from "classnames/bind";
import styles from "./SharePrice.module.scss";
import { ResolvedSharePrice } from "resolvers/data/sharePriceResolver";
import Button from "../Button";
import Image from "next/image";
import UIIcon from "../UIIcon";

const cx = classNames.bind(styles);

const SharePrice = (props: ResolvedSharePrice) => {
    return (
        <div className={cx("sharePriceContainer")}>
            <h2 className={cx("heading")}>{props.heading}</h2>
            <div className={cx("divider")} />
            <div className={cx("sharePriceData")}>
                <Image
                    className={cx("image")}
                    {...props.image}
                    alt={props.image.alt}
                    height={80}
                    width={80}
                />
                <div className={cx("sharePriceWrapper")}>
                    {props.sharePriceModel.changeType === "negative" && (
                        <UIIcon icon="ArrowDownOrange" className={cx("icon")} />
                    )}
                    {props.sharePriceModel.changeType === "positive" && (
                        <UIIcon icon="ArrowDownOrange" className={cx("iconFlipped")} />
                    )}
                    <span className={cx("sharePrice")}>{props.sharePriceModel.lastTradePrice}</span>
                    <span className={cx("sharePriceCurrency")}>GBx</span>
                </div>
                <span className={cx("sharePriceChange")}>
                    Change: {props.sharePriceModel.change} ({props.sharePriceModel.changePercent}%)
                </span>
            </div>
            <div className={cx("divider")} />
            <span className={cx("lastUpdated")}>
                Last updated: {props.sharePriceModel.tradeTimestamp}
            </span>
            {!!props.cta && (
                <div>
                    <Button
                        className={cx("ctaButton")}
                        href={props.cta.link}
                        theme={props.cta.priority}
                        target={props.cta.target}
                        autoWidth
                    >
                        {props.cta.text}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default SharePrice;
